import React from "react";
import clx from "classnames";
import styles from "./TableCell.module.css";

interface Props {
    children: React.ReactNode;
    hiddenMobile?: boolean;
    maxWidth?: `${number}rem`;
    minWidth?: `${number}rem`;
    // we're using this for min width's and max widths only e.g. sm:min-w-[10rem]
    className?: `${"sm:" | "md:" | "lg:" | "xl:" | ""}${"min-w" | "max-w"}-[${number}rem]`;

    align?: "left" | "right" | "center" | "justify" | "char";
}

const TableCell = ({
    children,
    hiddenMobile,
    maxWidth,
    minWidth,
    className,

    align,
}: Props) => {
    const cn = clx(
        {
            "hidden md:table-cell": hiddenMobile,
            [styles.tableCell]: true,
        },
        className
    );
    return (
        <td className={cn} style={{ maxWidth, minWidth }} align={align}>
            {children}
        </td>
    );
};

export default TableCell;
